<mat-card>
  <mat-card-header>
    <mat-card-title
      cdkDrag
      cdkDragHandle
      cdkDragRootElement=".cdk-overlay-pane"
    >
      {{ title }}
    </mat-card-title>
  </mat-card-header>

  <!-- Form -->
  <mat-card-content style="margin: 2em 0">
    <div style="height: 400px; width: 100%">
      <app-mapa-base
        [centro]="centro"
        [zoom]="16"
        [coordenadaMarker]="centro"
        [markerArrastrable]="data.markerDraggable"
        (coordenadaCambiada)="onCoordenadaCambiada($event)"
      ></app-mapa-base>
    </div>
  </mat-card-content>

  <mat-divider></mat-divider>

  <!-- Botones -->
  <mat-card-actions class="fx-row fx-gap-1em" style="margin: 0.5em">
    @if (data.markerDraggable) {
      <button
        mat-raised-button
        color="primary"
        (click)="guardar()"
        style="width: 50%"
      >
        Guardar
      </button>
    }
    <button
      mat-raised-button
      color="accent"
      type="button"
      (click)="close()"
      [style]="data.markerDraggable ? 'width: 50%' : 'width: 100%'"
    >
      Volver
    </button>
  </mat-card-actions>
</mat-card>
